import { render } from "./LoadingLayer.vue?vue&type=template&id=08b27033&ts=true"
import script from "./LoadingLayer.vue?vue&type=script&lang=ts"
export * from "./LoadingLayer.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__